<template>
	<v-row style="font-family:kalam">
		<v-col cols="12" xs="10" sm="10" md="10" offset-xs="0" offset-sm="1" offset-md="1">
			<h1>{{ $t('gallery') }}</h1>
		</v-col>
		<v-col cols="12" xs="10" sm="10" md="10" offset-sm="1" offset-md="1">
			<v-container fluid>
				<v-row fluid>
					<v-col v-for="(img, i) in imgSet" :key="i" cols="12" xs="12" sm="12" md="6">
						<v-card flat tile class="d-flex" style="padding:10">
							<v-img :src="img" :lazy-src="img" aspect-ratio="1" class="grey lighten-2">
								<template v-slot:placeholder>
									<v-row class="fill-height ma-0" align="center" justify="center">
										<v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
									</v-row>
								</template>
							</v-img>
						</v-card>
					</v-col>
				</v-row>
				<ToTopButton/>
			</v-container>
		</v-col>
	</v-row>
</template>

<script>
import ToTopButton from './ToTopButton.vue'

function generateDataSet() {
	let imageArray = []
	// current amount of images is 32
	for(let i=32; i>0; --i ) {
		if(i < 10) {
			imageArray.push(require(`@/assets/images/img_0${i}.jpg`))
		} else {
			imageArray.push(require(`@/assets/images/img_${i}.jpg`))
		}
	}
	return imageArray
}

export default {
	name: 'GalleryComp',
	components: { ToTopButton },
	data: () => ({
		imgSet: generateDataSet(),
	}),
}
</script>
